import { Sparkles } from "lucide-react";

export const SorteioSection = ({ sectionRef, isVisible }) => {
  const brindes = [
    "Mergulho com cilindro",
    "Hospedagem e janta na região", 
    "50% de desconto em cursos",
    "Até 30% desconto em viagens com a escola",
    "Camiseta",
    "Poncho",
    "Equipamento de mergulho",
    "E muito mais!"
  ];

  return (
    <section 
      ref={sectionRef}
      className={`py-12 md:py-16 bg-gradient-to-b from-[#009C3B] to-[#007830] text-white transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      data-testid="sorteio-section"
    >
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="font-heading text-3xl md:text-4xl text-white mb-4">
          TODO PASSEIO TERMINA COM UM SORTEIO!
        </h2>
        <p className="text-white/90 mb-8 max-w-2xl mx-auto">
          Cada saída tem um <strong className="text-[#FFDF00]">brinde diferente</strong> para sortear entre os participantes!
        </p>
        
        <div className="flex flex-wrap justify-center gap-3 mb-8">
          {brindes.map((item) => (
            <div key={`brinde-${item.replace(/\s/g, '-').toLowerCase()}`} className="bg-white/20 backdrop-blur-sm rounded-full px-4 py-2 text-sm text-white border border-white/30 shadow-md hover:shadow-lg transition-shadow">
              <Sparkles className="w-4 h-4 inline mr-2 text-[#FFDF00]" />
              {item}
            </div>
          ))}
        </div>
        
        {/* Frase de Status */}
        <div className="text-center mt-8 bg-white/20 backdrop-blur-sm rounded-2xl p-6 max-w-2xl mx-auto border border-white/30">
          <p className="text-white text-lg md:text-xl leading-relaxed">
            <strong className="text-[#FFDF00]">Esse não é um passeio comum.</strong><br/>
            É o tipo de experiência que as pessoas vivem… e <strong className="text-[#FFDF00]">todo mundo pergunta onde foi.</strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default SorteioSection;
